import { jsx as _jsx } from "react/jsx-runtime";
import { useNumericFormat, NumberFormatBase } from 'react-number-format';
import { numericFormatter } from 'react-number-format';
// Comma used for mobile keyboards
const DECIMAL_SEPARATORS = [',', '.'];
export const numericInputZero = () => ({
    floatValue: 0,
    formattedValue: '0',
    value: '0',
});
export const numericInputEmpty = () => ({
    floatValue: undefined,
    formattedValue: '',
    value: '',
});
export const NumericInput = ({ decimalScale = 10, formatterRef, onFocus, placeholder = '0', inputMode = 'decimal', ref, ...inputProps }) => {
    const numericFormatProps = useNumericFormat({
        allowedDecimalSeparators: DECIMAL_SEPARATORS,
        thousandSeparator: ',',
        decimalSeparator: '.',
        decimalScale: decimalScale,
        allowNegative: false,
        allowLeadingZeros: false,
        getInputRef: ref,
        inputMode,
        placeholder,
        ...inputProps,
    });
    if (formatterRef) {
        formatterRef.current = (value) => numericFormatter(value, numericFormatProps);
    }
    return (_jsx(NumberFormatBase, { ...numericFormatProps, onFocus: (e) => {
            e.target.selectionStart = e.target.value.length;
            onFocus?.(e);
        } }));
};
//# sourceMappingURL=numeric-input.js.map